import { fn } from '@ember/helper';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { PrismButton, PrismCard } from '@mylighthouse/prism-ember';
// @ts-expect-error: Cannot find module '@zestia/ember-simple-infinite-scroller/components/infinite-scroller' or its corresponding type declarations.
import InfiniteScroller from '@zestia/ember-simple-infinite-scroller/components/infinite-scroller';
import { t } from 'ember-intl';
import { IncrementFor } from 'frontend-utils';
import ParityInsightBreakdownBlock from 'lumen/components/parity/insight/breakdown-block';
import ParityInsightBreakdownBlockTitle from 'lumen/components/parity/insight/breakdown-block-title';
import ParityInsightBreakdownValueLoading from 'lumen/components/parity/insight/breakdown-value-loading';
import ParityInsightHotelsValue from 'lumen/components/parity/insight/hotels-value';
import type ParityInsightSegmentationItem from 'lumen/models/parity/insight/segmentation-item';

import styles from './hotels-block.module.css';

export default class ParityInsightHotelsBlock extends ParityInsightBreakdownBlock {
  get allSegmentationObjects(): {
    depth: number;
    item: ParityInsightSegmentationItem;
  }[] {
    const items = this.sortedSegmentationObjects;

    if (!this.isSearchActive || !this.searchValue) {
      return items.map((item) => ({ depth: 0, item }));
    }

    return items
      .filter((item) => this.fuzzyMatchedItems.has(item))
      .map((item) => ({ depth: 0, item }));
  }

  <template>
    <div ...attributes>
      <PrismCard @contentLayout="noPadding" class="relative overflow-hidden">
        <:header as |Header|>
          {{! @glint-expect-error: Property 'disabledTooltipMessage' is missing }}
          <ParityInsightBreakdownBlockTitle
            @cardHeader={{Header}}
            @params={{this.titleParams}}
          />
        </:header>

        <:headerAfter>
          <div class="flex items-center gap-50">
            {{#if this.isSearchActive}}
              <PrismButton
                @buttonType="ghost"
                @icon="cross"
                @onClick={{fn this.toggleSearch false}}
              />
            {{else}}
              <PrismButton
                @buttonType="ghost"
                @icon="search"
                @onClick={{fn this.toggleSearch true}}
                data-event-id="market-parity-insight-breakdown-search"
                data-event-value={{this.segmentationName}}
              />
              <PrismButton
                @buttonType="ghost"
                @icon="expand"
                @onClick={{this.expandPopup}}
                data-event-id="market-parity-insight-breakdown-expand"
                data-event-value={{this.segmentationName}}
              />
            {{/if}}
          </div>
        </:headerAfter>

        <:content>
          <div class={{styles.container}}>
            <InfiniteScroller
              @onLoadMore={{this.loadMore}}
              @percent={{90}}
              class={{styles.infinite-scroller}}
              {{didInsert this.didInsertInfiniteScroll}}
            >
              {{#if this.displayedSegmentationObjects.length}}
                {{#each
                  this.displayedSegmentationObjects
                  as |segmentationValue|
                }}
                  <ParityInsightHotelsValue
                    {{! @glint-expect-error: Type 'ParityInsightSegmentationItem | BreakdownItemOther' is not assignable to type 'ParityInsightSegmentationItem'. }}
                    @data={{segmentationValue.item}}
                    {{! @glint-expect-error: Property 'hasSearchValue' does not exist on type 'ParityInsightHotelsBlock'. }}
                    @hasSearchValue={{this.hasSearchValue}}
                    {{! @glint-expect-error: Type 'HotelViewFilters | undefined' is not assignable to type 'HotelViewFilters'. }}
                    @hotelViewFilters={{@hotelViewFilters}}
                    {{! @glint-expect-error: Property 'maxBlockValue' does not exist on type 'ParityInsightHotelsBlock'. }}
                    @maxBlockValue={{this.maxBlockValue}}
                    @maxNbOfShops={{this.maxNbOfShops}}
                    @onSegmentationFilterClicked={{@segmentationFilterClicked}}
                    @parsedSegmentationFilters={{@parsedSegmentationFilters}}
                    @resetIndex={{this.resetIndex}}
                    {{! @glint-expect-error: Property 'segmentationBlockIdx' does not exist on type 'ParityInsightHotelsBlock'. }}
                    @segmentationBlockIdx={{this.segmentationBlockIdx}}
                    @sortType={{@sortType}}
                    @triggerScrollbarUpdate={{this.triggerScrollbarUpdate}}
                    class="hotels-value"
                  />
                {{/each}}
              {{else if @showLoadingPlaceholderState}}
                <IncrementFor @times={{5}}>
                  <ParityInsightBreakdownValueLoading />
                </IncrementFor>
              {{else}}
                <p class="text-300--regular mt-200 ml-500">
                  {{t "general.no_results"}}
                </p>
              {{/if}}
            </InfiniteScroller>
          </div>
        </:content>
      </PrismCard>
    </div>
  </template>
}
